// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--1lbc-";
export var textSide = "styles-module--textSide--3-pQ3";
export var content = "styles-module--content--3zsH_";
export var imageSide = "styles-module--imageSide--2HNWg";
export var mobileIconWrapper = "styles-module--mobileIconWrapper--1cTNN";
export var imageCol = "styles-module--imageCol--198TZ";
export var leftPart = "styles-module--leftPart--1x5t3";
export var rightPart = "styles-module--rightPart--24YL-";
export var buttonWrapper = "styles-module--buttonWrapper--1kjZb";